<rt-dropdown [width]="DropdownWidth.FullWidth">
  <div class="content">
    @for (button of buttons; track trackByValue(i, button); let i = $index) {
      @if (button.isDropdown) {
        <rt-button
          #origin
          [dropdownOpened]="button.isActive(editorView.state)"
          variant="plain"
          size="small"
          (click)="onButtonClick(button, origin.elRef.nativeElement)"
        >
          <ng-container
            *ngTemplateOutlet="buttonDropdownContent; context: { button }"
          ></ng-container>
        </rt-button>
      } @else if (button.name) {
        <rt-button
          #origin
          [pressed]="buttonsState[i]"
          variant="plain"
          size="small"
          (click)="onButtonClick(button, origin.elRef.nativeElement)"
        >
          <rt-icon [name]="$any(button.icon)"></rt-icon>
          <span>{{ button.name }}</span>
        </rt-button>
        @if (!$last) {
          <div class="separator"></div>
        }
      } @else {
        <rt-icon-button
          #origin
          [pressed]="buttonsState[i]"
          [iconName]="$any(button.icon)"
          variant="plain"
          size="small"
          (click)="onButtonClick(button, origin.elRef.nativeElement)"
        ></rt-icon-button>
      }
    }
  </div>
</rt-dropdown>

<ng-template #buttonDropdownContent let-button="button" [ngTemplateType]="ButtonContentType">
  @if (button.icon) {
    <rt-icon [name]="$any(button.icon)"></rt-icon>
  }
  <span>{{ button | rtEditorButtonLabel: editorView }}</span>
  @if (button.iconRight) {
    <rt-icon
      [name]="$any(button.iconRight)"
      [colorToken]="$any(button.iconRightColor)"
      size="small-x"
    ></rt-icon>
  }
</ng-template>
